/**
 * Image Component.
 * 
 * If no src if provided, a placeholder box will be shown.
 */
import { ReactComponent as ImageIcon } from 'assets/icons/image.svg';

interface ImageProps {
    src?: string
    alt?: string
    size?: 'sm'|'md'|'lg'
    width?: 'full' | 'auto'
}

const Image: React.FC<ImageProps> = ({ src, alt, size = 'md', width = 'auto' }) => {

    let classes = `bg-gray-200 flex items-center justify-center`

    switch (size) {
        case 'sm':
            classes += ` ${width === 'full' ? 'w-full' : 'w-10'} h-10`
            break
        case 'md':
            classes += ` ${width === 'full' ? 'w-full' : 'w-20'} h-20`
            break
        case 'lg':
            classes += ` ${width === 'full' ? 'w-full' : 'w-40'} h-40`
            break
    }

    return (
        <div className={classes}>
            {src ? <img 
                src={src} 
                alt={alt} 
                className={`product-thumbnail max-h-full max-w-full`}
            /> : <ImageIcon />}
        </div>
    )
}

export default Image

